export default __webpack_public_path__ + "static/media/butterfly.e8f2a4d9.svg";